import React from "react"
import { Col, Row } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { PageLayout, PageTitle } from "../components"
import { SEO } from "../utils"

const ContactItem = ({ label, href, handle, description }) => (
  <div>
    <h4 className="contact-item-title">
      {label}:&nbsp;{" "}
      <a href={href} target="_blank" rel="noopener noreferrer">
        {handle}
      </a>
    </h4>
    <p>{description}</p>
    <hr />
  </div>
)

const contacts = [
  {
    label: "Email",
    href: "mailto:moafembe@gmail.com",
    handle: "moafembe@gmail.com",
    description:
      "J'utilise beaucoup ma boite mail. Laissez moi un message, Je vous répondrai rapidement.",
  },
  {
    label: "Youtube",
    href: "https://www.youtube.com/@regisatemengue",
    handle: "Régis ATEMENGUE",
    description:
      "J'ai démarré une chaine Youtube pour partager mes connaissances et mon savoir faire. Merci de rejoindre ma communauté.",
  },
  {
    label: "Tiktok",
    href: "https://www.tiktok.com/@regisatemengue",
    handle: "Régis ATEMENGUE",
    description: "J'ai commencé à partager sur TikTok. Merci de rejoindre ma communauté.",
  },
  {
    label: "Twitter",
    href: "https://twitter.com/regis_ate",
    handle: "@regis_ate",
    description:
      "Mon fil d'actualité Twitter est basé sur la TECH. Je lis mes DM mais je préférerais les e-mails si vous me contactez à l'improviste.",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/regis-atemengue",
    handle: "regis-atemengue",
    description:
      "Mon parcours est assez bien couvert sur les 3 dernières années. J'accepte les relations des futurs clients et/ou partenaires.",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/regis_ate/",
    handle: "@regis_ate",
    description:
      "Sur Instagram vous retrouvez quelques photos, code et mon environnement de travail.",
  },
]

export default () => {
  return (
    <PageLayout pageName="contact">
      <SEO title="Contacts" />
      <PageTitle title="Contacts" />
      <Container className="text-left">
        <Row>
          <Col md="8 offset-md-2">
            <p className="contact-intro">
              Je suis généralement assez facile à joindre, vous pouvez utiliser
              les différents canaux suivants :
            </p>
            {contacts.map(item => (
              <ContactItem key={item.label} {...item} />
            ))}
          </Col>
        </Row>
      </Container>
    </PageLayout>
  )
}
